<template>
    <div class="p-mypage__account p-mypage__account--delete mypage-bloc">
    <div class="mypage-bloc__head">
        <h2>{{ $t("LABEL_DELETE_ACCOUNT") }}</h2>
    </div>
    <div class="mypage-bloc__content">
        <div class="delete__setting">
        <p v-html="$t('TEXT_RESIGN_EXPLANATION')"></p>
        <div class="setting">
            <p>{{ $t("TEXT_RESIGN_WARNING") }}</p>
            <button :disabled="!userStore.canDeleteAccount" id="btn-delete-account" class="c-btn__account c-btn__account--delete">{{ $t("TEXT_DELETE_ACCOUNT")
            }}</button>
        </div>
        </div>
        <div v-if="!userStore.canDeleteAccount && userStore.activeMerchants.length" class="merchant-list__section">
            <p class="merchant-list__title">{{ $t("TEXT_ACTIVE_MERCHANTS") }}</p>

            <ul class="merchant-list">
                <li
                    v-for="merchant in userStore.activeMerchants"
                    :key="merchant.id"
                    class="merchant-list__item"
                >
                    <a
                        v-if="merchant.registered_applications.app_resign_url"
                        :href="merchant.registered_applications.app_resign_url"
                        class="merchant-list__link"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span>{{ merchant.registered_applications.site_name }}</span>
                        <span class="merchant-list__arrow">↗</span>
                    </a>

                    <span
                        v-else
                        class="merchant-list__link merchant-list__link--disabled"
                        :aria-disabled="true"
                    >
                        <span>{{ merchant.registered_applications.site_name }}</span>
                        <span class="merchant-list__arrow">↗</span>
                    </span>
                </li>
            </ul>
            <router-link v-if="!userStore.canDeleteAccount" :to="{ name: 'merchant.list' }" class="c-link c-link--contact">{{ $t("LABEL_CLICK_HERE_FOR_MERCHANT_LIST") }}</router-link>
        </div>
    </div>
    </div>
</template>

<script setup>
import { useUserStore } from "@/stores/userStore";
const userStore = useUserStore();
</script>

<style scoped>
.merchant-list__section {
    margin-top: 28px;
    padding: 20px;
    border: 1px solid #ebebeb;
    border-radius: 8px;
    background-color: #fafafa;
}

.merchant-list__title {
    margin: 0 0 12px;
    font-size: 15px;
    font-weight: 600;
    color: #333;
}

.merchant-list {
    margin: 0;
    padding: 0;
    list-style: none;
}

.merchant-list__item + .merchant-list__item {
    margin-top: 8px;
}

.merchant-list__link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 6px;
    background-color: #fff;
    color: #2d3a8c;
    font-size: 15px;
    font-weight: 500;
    text-decoration: none;
    transition: background-color 0.2s, color 0.2s;
}

.merchant-list__link:hover {
    background-color: #f0f3ff;
    color: #4866e0;
}

.merchant-list__arrow {
    flex-shrink: 0;
    font-size: 14px;
    color: #8a8a8a;
}

.merchant-list__link--disabled {
    color: #aaa;
    cursor: not-allowed;
    pointer-events: none;
    background-color: #f5f5f5;
}

.merchant-list__link--disabled .merchant-list__arrow {
    color: #c0c0c0;
}

.c-link--contact {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
    padding: 10px 14px;
    border-radius: 6px;
    background-color: #f0f3ff;
    color: #2d3a8c;
    font-size: 15px;
    font-weight: 500;
    text-decoration: none;
    transition: background-color 0.2s, color 0.2s;
    border: 1px solid #d9e2f7;
}

.c-link--contact:hover {
    background-color: #e0e9ff;
    color: #4866e0;
    border-color: #c0d0f2;
}
</style>